// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adgroup-form{
    display: flex;
    border: 1px solid #343A40 ;
    border-radius: 5px;
    padding: 10px 10px;
    position: relative;
    flex-direction: column;
}

.adgroup-form .buttons{
    position: absolute;
    bottom: 5px;
    right: -5px;
}

.adgroup-form .options-container{
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.optional-options .option{
    display: flex;
    flex-direction: column;
}
.tactic .tactic-label{
    margin-left: 5px;
}

.download-button:hover{
    cursor: pointer;
    background-color: #DEE2E6;
}

.list-container .single-list{
    margin: 10px 10px;
    display: flex;
    justify-content: space-between;
}

.main-des{
    display: flex;
    flex-direction: column;
}

.main-des span{
    color: red;
    font-size: 15px;
}

.descriptor{
    display: flex;
}

.descriptor span{
    color:  red;
    font-size: 12px;
    margin-right: 5px;
}

.additional-context{
    display: flex;
    flex-direction: column;
}

.additional-context span{
    color: red;
}

.descriptor .input-label{
    margin-right: 5px;
}

.buttons{
    margin-right: 10px;
    display: flex;
    width: 150px;
    justify-content: space-around;
}

.buttons button{
    padding: 2px 5px;
}

.main-des span{
    font-size: 12px;
}

.additional-context span{
    font-size: 12px;
}

.form-container input[type='text']{
    margin-left: 0px;
}

.creative-form .options-container{
    width: 100%;
}

.options-container select{
    margin: 0px 4px;
}

.input-label{
    margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/adgroup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".adgroup-form{\n    display: flex;\n    border: 1px solid #343A40 ;\n    border-radius: 5px;\n    padding: 10px 10px;\n    position: relative;\n    flex-direction: column;\n}\n\n.adgroup-form .buttons{\n    position: absolute;\n    bottom: 5px;\n    right: -5px;\n}\n\n.adgroup-form .options-container{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.optional-options .option{\n    display: flex;\n    flex-direction: column;\n}\n.tactic .tactic-label{\n    margin-left: 5px;\n}\n\n.download-button:hover{\n    cursor: pointer;\n    background-color: #DEE2E6;\n}\n\n.list-container .single-list{\n    margin: 10px 10px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.main-des{\n    display: flex;\n    flex-direction: column;\n}\n\n.main-des span{\n    color: red;\n    font-size: 15px;\n}\n\n.descriptor{\n    display: flex;\n}\n\n.descriptor span{\n    color:  red;\n    font-size: 12px;\n    margin-right: 5px;\n}\n\n.additional-context{\n    display: flex;\n    flex-direction: column;\n}\n\n.additional-context span{\n    color: red;\n}\n\n.descriptor .input-label{\n    margin-right: 5px;\n}\n\n.buttons{\n    margin-right: 10px;\n    display: flex;\n    width: 150px;\n    justify-content: space-around;\n}\n\n.buttons button{\n    padding: 2px 5px;\n}\n\n.main-des span{\n    font-size: 12px;\n}\n\n.additional-context span{\n    font-size: 12px;\n}\n\n.form-container input[type='text']{\n    margin-left: 0px;\n}\n\n.creative-form .options-container{\n    width: 100%;\n}\n\n.options-container select{\n    margin: 0px 4px;\n}\n\n.input-label{\n    margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
